(function () {
  if (window.__gwpPdpInit) return;
  window.__gwpPdpInit = true;

  // This file is only ever loaded (by layout/theme.liquid) on the configured
  // gwp_trigger_product's own page, so no further per-product check is needed
  // here. The subscribe/one-time selector itself is rendered client-side by
  // ReCharge's widget.min.js into .rc-widget-injection-parent - .rc_widget__option--subsave
  // and .rc_widget__option--onetime are ReCharge's own classes, shared by every
  // theme variant script in assets/recharge-widget-variants*.js, so they're a
  // stable anchor regardless of which variant script applies to this product.
  // The band is injected into both option cards independently (each gets its
  // own element + countdown interval).

  // Every other stylesheet touching this widget (recharge-widget-variants*.css,
  // recharge-new.css, the shadow-DOM CSS in layout/theme.liquid) leans on
  // !important throughout specifically because it's fighting the widget's own
  // !important-heavy rules - this block previously had none, which is very
  // likely why declarations here (display, flex sizing, wrapping) were losing
  // that fight. flex-wrap:wrap on the body is a safety net so the thumbnails
  // drop below the text instead of overlapping it if space is ever still
  // tight for any other reason.
  var PDP_BAND_CSS = [
    '.gwp-pdp-band {',
    '  display: block !important;',
    '  flex: 1 1 100% !important;',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  box-sizing: border-box !important;',
    '  margin-top: 22px !important;',
    '  background: #ECF4EF !important;',
    '  border-radius: 14px !important;',
    '  padding: 16px 18px !important;',
    '  font-family: studiofeixen, sans-serif !important;',
    '  white-space: normal !important;',
    '}',
    '.gwp-pdp-band__head {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: space-between !important;',
    '  flex-wrap: wrap !important;',
    '  gap: 8px 12px !important;',
    '  margin-bottom: 9px !important;',
    '}',
    '.gwp-pdp-band__label-row {',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  gap: 9px !important;',
    '  background: #ECF166 !important;',
    '  border-radius: 54px !important;',
    '  padding: 9px 18px !important;',
    '}',
    '.gwp-pdp-band__label {',
    '  font-size: 11px !important;',
    '  line-height: 11px !important;',
    '  font-weight: 500 !important;',
    '  letter-spacing: 0.12em !important;',
    '  text-transform: uppercase !important;',
    '  color: #244545 !important;',
    '  white-space: nowrap !important;',
    '}',
    '.gwp-pdp-band__countdown {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  gap: 6px !important;',
    '  font-size: 12px !important;',
    '  font-weight: 600 !important;',
    '  color: #244545 !important;',
    '  white-space: nowrap !important;',
    '}',
    '.gwp-pdp-band__dot {',
    '  width: 6px !important;',
    '  height: 6px !important;',
    '  border-radius: 54px !important;',
    '  background: #34B78F !important;',
    '  animation: gwp-pdp-pulse 1.6s ease-in-out infinite;',
    '}',
    '@keyframes gwp-pdp-pulse {',
    '  0%, 100% { opacity: 1; }',
    '  50% { opacity: .55; }',
    '}',
    '@media (prefers-reduced-motion: reduce) {',
    '  .gwp-pdp-band__dot { animation: none !important; }',
    '}',
    '.gwp-pdp-band__body {',
    '  display: flex !important;',
    '  flex-wrap: wrap !important;',
    '  gap: 16px !important;',
    '  align-items: center !important;',
    '  width: 100% !important;',
    '  min-width: 0 !important;',
    '}',
    '.gwp-pdp-band__textcol {',
    '  flex: 1 1 220px !important;',
    '  min-width: 0 !important;',
    '  max-width: 100% !important;',
    '}',
    '.gwp-pdp-band__text {',
    '  margin: 0 !important;',
    '  font-size: 14px !important;',
    '  line-height: 19px !important;',
    '  font-weight: 500 !important;',
    '  color: #244545 !important;',
    '  white-space: normal !important;',
    '  overflow-wrap: break-word !important;',
    '  word-break: break-word !important;',
    '}',
    '.gwp-pdp-band__list {',
    '  display: flex !important;',
    '  flex-direction: column !important;',
    '  gap: 6px !important;',
    '  margin-top: 10px !important;',
    '  font-size: 14px !important;',
    '  line-height: 1.3 !important;',
    '  color: #244545 !important;',
    '}',
    '.gwp-pdp-band__list-item {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  gap: 9px !important;',
    '  min-width: 0 !important;',
    '}',
    '.gwp-pdp-band__list-item svg {',
    '  flex: none !important;',
    '}',
    '.gwp-pdp-band__list-item span {',
    '  flex: 1 !important;',
    '  min-width: 0 !important;',
    '  font-weight: 500 !important;',
    '  white-space: normal !important;',
    '  overflow-wrap: break-word !important;',
    '  word-break: break-word !important;',
    '}',
    '.gwp-pdp-band__value {',
    '  color: #6D7878 !important;',
    '}',
    '.gwp-pdp-band__value s {',
    '  text-decoration: line-through !important;',
    '}',
    '.gwp-pdp-band__free {',
    '  color: #34B78F !important;',
    '  font-weight: 500 !important;',
    '}',
    '.gwp-pdp-band__media {',
    '  flex: 0 0 auto !important;',
    '  display: flex !important;',
    '  gap: 10px !important;',
    '}',
    '.gwp-pdp-band__thumb {',
    '  width: 82px !important;',
    '  height: 82px !important;',
    '  border-radius: 12px !important;',
    '  overflow: hidden !important;',
    '  background: #fff !important;',
    '  flex: none !important;',
    '}',
    '.gwp-pdp-band__thumb img {',
    '  display: block !important;',
    '  width: 100% !important;',
    '  height: 100% !important;',
    '  max-width: 100% !important;',
    '  object-fit: cover !important;',
    '}',
    '@media (max-width: 749px) {',
    '  .gwp-pdp-band__media { display: none !important; }',
    '}',
    // Theme's own built-in ::before/::after nudge on .onetime-elements-wrapper
    // (main-product.liquid) renders a "A może jednak subskrypcja?" box below
    // the real content, with padding-bottom reserved to fit it. Per the
    // updated design, the trigger product's onetime card replaces that with
    // the .gwp-pdp-upsell line below instead - the real "Dostawa 15 zł"
    // content (.product__subscription--single-purchase) stays visible as-is.
    '.onetime-elements-wrapper:before,',
    '.onetime-elements-wrapper:after,',
    '#shopify-section-template--30788121887045__main .onetime-elements-wrapper:before,',
    '#shopify-section-template--30788121887045__main .onetime-elements-wrapper:after {',
    '  content: none !important;',
    '  display: none !important;',
    '}',
    '.onetime-elements-wrapper,',
    '#shopify-section-template--30788121887045__main .onetime-elements-wrapper {',
    '  padding-bottom: 0 !important;',
    '}',
    '.gwp-pdp-upsell {',
    '  display: block !important;',
    '  width: 100% !important;',
    '  box-sizing: border-box !important;',
    '  margin-top: 18px !important;',
    '  font-size: 14px !important;',
    '  line-height: 19px !important;',
    '  color: #3C4B4B !important;',
    // .rc_widget__option--onetime (ReCharge widget base CSS) sets
    // white-space: nowrap, which this element otherwise inherits - without
    // resetting it here the whole line refuses to wrap and overflows the card.
    '  white-space: normal !important;',
    '}',
    '.gwp-pdp-upsell strong {',
    '  font-weight: 500 !important;',
    '  color: #244545 !important;',
    '}',
    '.gwp-pdp-upsell a {',
    '  color: #244545 !important;',
    '  font-weight: 500 !important;',
    '  text-decoration: underline !important;',
    '  text-underline-offset: 0.22em !important;',
    '  white-space: nowrap !important;',
    '  cursor: pointer !important;',
    '}'
  ].join('\n');

  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#34B78F" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6"></path></svg>';
  var GIFT_SVG = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#244545" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8"></path><path d="M2 7h20v5H2z"></path><path d="M12 22V7"></path><path d="M12 7S9.5 3 7.5 3.5 6 7 6 7s3-.2 6 0zM12 7s2.5-4 4.5-3.5S18 7 18 7s-3-.2-6 0z"></path></svg>';

  function injectStyles() {
    if (document.getElementById('gwp-pdp-band-styles')) return;
    var style = document.createElement('style');
    style.id = 'gwp-pdp-band-styles';
    style.textContent = PDP_BAND_CSS;
    document.head.appendChild(style);
  }

  // Merchant enters YYYY-MM-DD, optionally followed by HH:MM (space or "T"
  // separated). Parsed as local time rather than via `new Date(str)` (which
  // reads date-only ISO strings as UTC midnight) so a merchant-entered date
  // matches what a storefront visitor sees regardless of their timezone.
  // Missing time defaults to end-of-day (23:59:59), same as before this
  // supported an explicit time.
  function parseEndDate(str) {
    if (!str) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/.exec(str);
    if (!m) return null;
    var hasTime = m[4] !== undefined;
    return new Date(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      hasTime ? parseInt(m[4], 10) : 23,
      hasTime ? parseInt(m[5], 10) : 59,
      hasTime ? 0 : 59
    );
  }

  function formatCountdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var dayWord = d === 1 ? 'dzień' : 'dni';
    return d + ' ' + dayWord + ' ' + h + ' godz ' + m + ' min ' + s + ' sek';
  }

  function buildBand(config, endDate) {
    var wrap = document.createElement('div');
    wrap.className = 'gwp-pdp-band';

    var head = document.createElement('div');
    head.className = 'gwp-pdp-band__head';

    var labelRow = document.createElement('div');
    labelRow.className = 'gwp-pdp-band__label-row';
    labelRow.innerHTML = GIFT_SVG;
    var label = document.createElement('span');
    label.className = 'gwp-pdp-band__label';
    label.textContent = config.pdpEyebrow || 'Prezent do zamówienia';
    labelRow.appendChild(label);
    head.appendChild(labelRow);

    var countdown = document.createElement('span');
    countdown.className = 'gwp-pdp-band__countdown';
    var dot = document.createElement('span');
    dot.className = 'gwp-pdp-band__dot';
    countdown.appendChild(dot);
    var countdownText = document.createElement('span');
    countdownText.setAttribute('data-gwp-countdown', '1');
    countdownText.textContent = 'zostało ' + formatCountdown(endDate.getTime() - Date.now());
    countdown.appendChild(countdownText);
    head.appendChild(countdown);

    wrap.appendChild(head);

    var body = document.createElement('div');
    body.className = 'gwp-pdp-band__body';

    var textCol = document.createElement('div');
    textCol.className = 'gwp-pdp-band__textcol';

    var text = document.createElement('p');
    text.className = 'gwp-pdp-band__text';
    text.textContent = config.pdpDescription || '';
    textCol.appendChild(text);

    var list = document.createElement('div');
    list.className = 'gwp-pdp-band__list';
    config.gifts.forEach(function (gift) {
      var item = document.createElement('div');
      item.className = 'gwp-pdp-band__list-item';
      item.innerHTML = CHECK_SVG;
      var span = document.createElement('span');
      span.textContent = gift.title || '';
      if (gift.price) {
        var value = document.createElement('span');
        value.className = 'gwp-pdp-band__value';
        value.appendChild(document.createTextNode(' ('));
        var strike = document.createElement('s');
        strike.textContent = gift.price;
        value.appendChild(strike);
        value.appendChild(document.createTextNode(' '));
        var free = document.createElement('span');
        free.className = 'gwp-pdp-band__free';
        free.textContent = '0 zł';
        value.appendChild(free);
        value.appendChild(document.createTextNode(')'));
        span.appendChild(value);
      }
      item.appendChild(span);
      list.appendChild(item);
    });
    textCol.appendChild(list);
    body.appendChild(textCol);

    var media = document.createElement('div');
    media.className = 'gwp-pdp-band__media';
    config.gifts.forEach(function (gift) {
      if (!gift.image) return;
      var thumb = document.createElement('div');
      thumb.className = 'gwp-pdp-band__thumb';
      var img = document.createElement('img');
      img.src = gift.image;
      img.alt = gift.title || '';
      img.loading = 'lazy';
      thumb.appendChild(img);
      media.appendChild(thumb);
    });
    if (media.children.length) body.appendChild(media);

    wrap.appendChild(body);
    return wrap;
  }

  // Onetime-only upsell replacing the "Dostawa 15 zł" static block (hidden via
  // PDP_BAND_CSS above): nudges the shopper toward the subscription option by
  // clicking its own ReCharge label, the same element a real click on that
  // card would target - .rc_widget__option__label is what the widget's own
  // click-to-select handling is wired to (see recharge-widget-variants*.js).
  function buildUpsell() {
    var wrap = document.createElement('div');
    wrap.className = 'gwp-pdp-upsell';

    var strong = document.createElement('strong');
    strong.textContent = 'Chcesz oszczędzać na każdym słoiczku? ';
    wrap.appendChild(strong);

    var link = document.createElement('a');
    link.href = '#';
    link.textContent = 'Przełącz na subskrypcję →';
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var subLabel = document.querySelector('.rc-option__subsave .rc_widget__option__label') ||
        document.querySelector('.rc-radio.rc-option__subsave');
      if (subLabel) subLabel.click();
    });
    wrap.appendChild(link);

    return wrap;
  }

  // Tracked per-band (not in a single shared variable) since the subsave and
  // onetime cards each get their own independent band + interval.
  function startCountdown(band, endDate) {
    if (band._gwpInterval) clearInterval(band._gwpInterval);
    band._gwpInterval = setInterval(function () {
      var remaining = endDate.getTime() - Date.now();
      if (remaining <= 0) {
        clearInterval(band._gwpInterval);
        band.remove();
        return;
      }
      var el = band.querySelector('[data-gwp-countdown]');
      if (el) el.textContent = 'zostało ' + formatCountdown(remaining);
    }, 1000);
  }

  var pendingCheck = null;

  function findFallbackAnchor(container, buyButton) {
    var node = buyButton;
    while (node.parentNode && node.parentNode !== container) {
      node = node.parentNode;
    }
    return node.parentNode === container ? node : null;
  }

  // CONFIRMED CORRECT for the subsave card - do not change without a live
  // devtools outerHTML dump of .rc_widget__option--subsave first. Finds the
  // closest ancestor shared between the buy button and the quantity/selling
  // -plan control, then anchors directly before the button's row under that
  // ancestor - lands the band between the frequency/quantity row and the
  // button's row, which is how this card is actually laid out.
  function findInsertAnchorForSub(container) {
    var buyButton = container.querySelector('.product-form__submit');
    if (!buyButton) return null;

    var qtyOrPlanEl = container.querySelector('input[name="quantity"], select[name="selling_plan"]');
    if (!qtyOrPlanEl) return findFallbackAnchor(container, buyButton);

    var buttonAncestors = [];
    for (var n = buyButton; n; n = n.parentNode) buttonAncestors.push(n);

    var commonAncestor = null;
    for (var m = qtyOrPlanEl; m; m = m.parentNode) {
      if (buttonAncestors.indexOf(m) !== -1) {
        commonAncestor = m;
        break;
      }
    }
    if (!commonAncestor || commonAncestor === buyButton || commonAncestor === qtyOrPlanEl) {
      return findFallbackAnchor(container, buyButton);
    }

    var buttonRow = buyButton;
    while (buttonRow.parentNode && buttonRow.parentNode !== commonAncestor) {
      buttonRow = buttonRow.parentNode;
    }
    return buttonRow.parentNode === commonAncestor ? buttonRow : findFallbackAnchor(container, buyButton);
  }

  // CONFIRMED CORRECT for the onetime card via an actual devtools outerHTML
  // dump - do not change without a fresh one. ".addToCart-wrapperOne" is a
  // synthetic div assets/recharge-widget-variants-platki.js builds at runtime
  // purely to hold a cloned buy button + a cloned quantity input side by side
  // (styled in assets/recharge-widget-variants.css:117 as display:flex;
  // flex-direction:row-reverse, collapsing to column-reverse under 1160px) -
  // nothing else ever belongs in it. The band must land as a sibling directly
  // before this wrapper, never inside it (inserting inside made it an
  // unaccounted-for third flex item, which broke both position and wrapping).
  function findInsertAnchorForOnetime(container) {
    var all = container.querySelectorAll('div[class*="addToCart-wrapper"]');
    for (var i = 0; i < all.length; i++) {
      if (/(^|\s)addToCart-wrapperOne(\s|$)/.test(all[i].className) && all[i].parentNode) {
        return all[i];
      }
    }
    var buyButton = container.querySelector('.product-form__submit');
    return buyButton ? findFallbackAnchor(container, buyButton) : null;
  }

  var ANCHOR_CONFIGS = [
    { selector: '.rc_widget__option--subsave', findAnchor: findInsertAnchorForSub },
    { selector: '.rc_widget__option--onetime', findAnchor: findInsertAnchorForOnetime, onetime: true }
  ];

  function ensureBand() {
    var config = window.giftWithPurchaseConfig;
    if (!config || !config.enabled || !config.gifts || !config.gifts.length) return;

    var endDate = parseEndDate(config.promoEndDate);
    if (!endDate || endDate.getTime() <= Date.now()) return;

    ANCHOR_CONFIGS.forEach(function (cfg) {
      var container = document.querySelector(cfg.selector);
      if (!container || container.querySelector('.gwp-pdp-band')) return;

      injectStyles();
      var band = buildBand(config, endDate);
      var anchor = cfg.findAnchor(container);
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(band, anchor);
      } else {
        container.appendChild(band);
      }
      startCountdown(band, endDate);

      if (cfg.onetime) {
        band.insertAdjacentElement('afterend', buildUpsell());
      }
    });
  }

  function scheduleCheck() {
    if (pendingCheck) clearTimeout(pendingCheck);
    pendingCheck = setTimeout(ensureBand, 150);
  }

  new MutationObserver(scheduleCheck).observe(document.body, { childList: true, subtree: true });
  scheduleCheck();
})();
